module.exports = __webpack_public_path__ + "img/Skip.550c438e.png";